import Swiper from 'swiper';

const paginationBulletRender = (swiper, index, className) => (`
        <li class="o-nav__item ${className}">
            <a class="c-slider-nav__link" href="#">&nbsp;</a>
        </li>
`);

const paginationOptions = (selector) => ({
    pagination          : selector,
    paginationClickable : true,
    paginationElement   : 'li',
    paginationType      : 'bullets',
    paginationBulletRender,
});

const ContentSlider = (function initContentSlider() {
    const selector = '.js-content-slider';

    function init() {
        /* eslint-disable no-unused-vars */
        const mySwiper = new Swiper(selector, {
            direction  : 'horizontal',
            loop       : true,
            nextButton : `${selector} .js-swiper-next`,
            prevButton : `${selector} .js-swiper-before`,
            effect     : 'coverflow',
            ...paginationOptions(`${selector} .js-swiper-nav`),
        });
        /* eslint-disable no-unused-vars */
    }

    return { init };
}());

const TripleSlider = (function initTripleSlider() {
    const selector = '.js-triple-slider';
    const breakpoint = 900;

    function init() {
        const mySwiper = new Swiper(selector, {
            direction     : 'horizontal',
            loop          : true,
            nextButton    : '.js-triple-next',
            prevButton    : '.js-triple-before',
            slidesPerView : 3,
            breakpoints   : {
                [breakpoint]: {
                    slidesPerView: 1,
                },
            },
            ...paginationOptions('.js-triple-nav'),
        });
    }

    return { init };
}());

const PanoramaSlider = (function initPanoramaSlider() {
    const selector = '.js-panorama-slider';

    function init() {
        /* eslint-disable no-unused-vars */
        const mySwiper = new Swiper(selector, {
            direction  : 'horizontal',
            loop       : true,
            nextButton : `${selector} .js-swiper-next`,
            prevButton : `${selector} .js-swiper-before`,
            ...paginationOptions(`${selector} .js-swiper-nav`),
        });
        /* eslint-disable no-unused-vars */
    }

    return { init };
}());

export default function () {
    TripleSlider.init();
    ContentSlider.init();
    PanoramaSlider.init();
}
